export default "__VITE_ASSET__CPZnpjyd__"